import { Controller } from "stimulus";

const API_URL = "https://www.youtube.com/iframe_api";

/**
 * YouTube player for the shared video modal. The modal controller loads
 * videos through the global `player` (see ModalController#openModal), and
 * this controller stops playback when the modal is closed.
 * https://developers.google.com/youtube/iframe_api_reference
 */
export default class YoutubePlayerController extends Controller {
  static targets = ["video"];

  connect() {
    if (window.YT && window.YT.Player) {
      this.createPlayer();
    } else {
      window.onYouTubeIframeAPIReady = () => this.createPlayer();
      this.loadApi();
    }
  }

  disconnect() {
    if (window.player && window.player.destroy) window.player.destroy();
    window.player = undefined;
  }

  stop() {
    if (window.player && window.player.loadVideoById) {
      window.player.loadVideoById("");
    }
  }

  createPlayer() {
    window.player = new YT.Player(this.videoTarget);
  }

  loadApi() {
    if (document.querySelector(`script[src="${API_URL}"]`)) return;

    const script = document.createElement("script");
    script.src = API_URL;
    document.head.appendChild(script);
  }
}
